/**
 * The engine's request-trace logging, in one place with one switch.
 *
 * BrowserDAV grew up in a browser tab where every request was traced to the
 * console on purpose (the debug console receiver reads it). In a Node
 * process that trace lands on stdout, where a runner's --json output lives,
 * so there it is off unless asked for. Since 2026-10-21 it is off in a
 * browser too unless asked for: a GeoCamera serving a few viewers logged
 * every proxied request in full, which filled the debug console's buffer
 * in minutes and hid the lines that mattered. Ask for it with
 * `config.debug`, `localStorage.setItem('acequia.trace', '1')` (that tab,
 * read once at load), `ACEQUIA_DEBUG=1` in Node, or setDavTrace(true).
 */
const isNode = typeof process !== 'undefined' && !!process.versions?.node

function askedFor() {
    if (isNode) return /^(1|true|yes)$/i.test(process.env.ACEQUIA_DEBUG || '')
    try { if (globalThis.localStorage?.getItem('acequia.trace') === '1') return true } catch { /* a worker, or storage blocked */ }
    return false
}

let forced = null // setDavTrace() wins over everything
const stored = askedFor()

export function setDavTrace(on) {
    forced = !!on
}

export function davTraceEnabled() {
    if (forced !== null) return forced
    return stored || !!globalThis.acequia?.config?.debug
}

/** console.log, when tracing is on. */
export function davTrace(...args) {
    if (davTraceEnabled()) console.log(...args)
}
